import { contact } from "./site";

// Mensajes finales de la sección 12.1 de la guía. Cada CTA de WhatsApp abre con el
// mensaje que corresponde a su contexto.
export const whatsappMessages = {
  general: "Hola, vengo de yvyrai.lat. Quiero saber cómo pueden ayudar a mi negocio.",
  yvyra: "Hola, vengo de yvyrai.lat. Me interesa probar Yvyra en mi negocio.",
  tajy: "Hola, vengo de yvyrai.lat. Me interesa Tajy. ¿Me avisan cuando esté disponible?",
  kaaguy: "Hola, vengo de yvyrai.lat. Tengo varias sedes y me interesa Ka'aguy.",
  custom: "Hola, vengo de yvyrai.lat. Quiero conversar sobre un modelo a medida.",
  prensa: "Hola, vengo de yvyrai.lat. Soy periodista y quiero hablar con el equipo.",
} as const;

export type WhatsappContext = keyof typeof whatsappMessages;

export function whatsappUrl(context: WhatsappContext = "general"): string {
  return `https://wa.me/${contact.whatsappNumber}?text=${encodeURIComponent(whatsappMessages[context])}`;
}
